import axios from 'axios'
import commonServices from "@/shared/commonServices"
export default {
    namespaced: true,
    state: {
        modulesPers: [],
        userPermissions: []
      },
      getters: {
        modulesPers(state) {
          return state.modulesPers
        },
        userPermissions(state) {
            return state.userPermissions
        },
        userHasPermission:(state) => (permission) => {
            let hasPermission = state.userPermissions.find(user_permission => user_permission == permission);
            return hasPermission ? true : false;
        },
      },
    mutations: {
        SET_MODULES(state, responseData) {
            state.modulesPers = responseData
        },
        SET_USER_PERMISSIONS(state, responseData) {
            state.userPermissions = responseData || [];
        },
    },
    actions: {
        async fetchModules(context) {
            try {
                const {apiURL} = commonServices.data();
                let response = await axios.get(apiURL + 'Modules/getModulesPermissions')
                if(response.data.status == 'success')
                context.commit('SET_MODULES', response.data.results)
            } catch (err) {
                console.log(err);
            }
        },
        async fetchUserPermissions(context) {
            try {
                const {apiURL} = commonServices.data();
                if (!localStorage.userId) return;
                
                let response = await axios.post(apiURL + 'Modules/getUserPermissions', { userId: localStorage.userId });
                if(response.data.status == 'success') {
                    let perms = response.data.results;
                    // Based on Users.vue logic, the first element seems to be a placeholder/dummy and is removed
                    if (perms && perms.length > 0) {
                        perms.splice(0, 1);
                    }
                    context.commit('SET_USER_PERMISSIONS', perms);
                    localStorage.userPermissions = JSON.stringify(perms);
                }
            } catch (err) {
                console.log(err);
            }
        }
    }
}
